import { clsx } from 'clsx'

function scoreColor(score: number) {
  if (score >= 80) return 'text-accent-success border-accent-success bg-accent-success-light'
  if (score >= 60) return 'text-emerald-600 border-emerald-600 bg-emerald-50'
  if (score >= 40) return 'text-accent-warning border-accent-warning bg-accent-warning-light'
  return 'text-accent-error border-accent-error bg-accent-error-light'
}

export default function ScoreBadge({ score, size = 'md' }: { score: number; size?: 'sm' | 'md' | 'lg' }) {
  const sizeClasses = {
    sm: 'w-10 h-10 text-sm',
    md: 'w-14 h-14 text-lg',
    lg: 'w-20 h-20 text-2xl',
  }

  return (
    <div
      className={clsx(
        'rounded-full border-2 flex items-center justify-center font-bold',
        sizeClasses[size],
        scoreColor(score),
      )}
    >
      {score}
    </div>
  )
}
